<script lang="ts" setup>
import type { SearchSectionRecord } from "~~/server/graphql/datocms/generated";

defineProps<{ data: SearchSectionRecord; pageTitle: string; currentPageId: string }>();
</script>

<template>
  <div class="mb-3xl lg:mb-5xl gap-2xl flex flex-col">
    <div class="gap-lg flex flex-col">
      <h1 class="text-center">
        {{ data.title }}
      </h1>

      <div v-if="data.optIntro" class="mx-auto text-center lg:max-w-[820px]" v-html="data.optIntro" />
    </div>

    <div class="mx-auto">
      <FormSearch mode="page" class="relative z-30 w-full" />
    </div>
  </div>
</template>

<style scoped>

</style>
